<!-- Product Navigation -->
<div class="product-nav" (mouseleave)="onNavMouseLeave()">
  <div class="nav-container">
    <button class="nav-arrow left" (click)="scrollLeft()">
      <i class='bx bx-chevron-left'></i>
    </button>

    <div class="nav-scroll" #categoryList>
      <div class="nav-items">
        <div *ngFor="let category of categories"
             class="nav-item"
             [class.active]="activeCategory === category"
             (mouseenter)="onCategoryMouseEnter(category, categoryEl)">
          <a class="nav-link">{{ category.name }}</a>
        </div>
      </div>
    </div>

    <button class="nav-arrow right" (click)="scrollRight()">
      <i class='bx bx-chevron-right'></i>
    </button>
  </div>

  <!-- Mega Menu -->
  <div class="mega-menu"
       *ngIf="activeCategory && activeCategory.subcategories?.length">
    <div class="mega-menu-inner">
      <div class="mega-menu-grid">
        <a *ngFor="let sub of activeCategory.subcategories"
           [routerLink]="['/subcategory', sub.id]"
           class="mega-menu-item">
          {{ sub.name }}
        </a>
      </div>
    </div>
  </div>
</div>

<!-- Mobile Menu -->
<div class="mobile-menu d-lg-none">
  <div class="mobile-header">
    <div class="mobile-logo">
      <a routerLink="/">
        <img src="assets/img/ufp_logo8.png" alt="Logo">
      </a>
    </div>
    <button class="mobile-toggle" (click)="toggleMobileMenu()">
      <i class='bx bx-menu'></i>
    </button>
  </div>

  <div class="mobile-nav" [class.open]="mobileMenuOpen">
    <div class="mobile-nav-inner">
      <a routerLink="/home" class="mobile-nav-link">Home</a>
      <a routerLink="/gallery" class="mobile-nav-link">Products</a>
      <a routerLink="/showroom-gallery" class="mobile-nav-link">Showroom Gallery</a>
      <a routerLink="/about" class="mobile-nav-link">About</a>
      <a routerLink="/contact" class="mobile-nav-link">Contact Us</a>

      <div *ngFor="let category of categories" class="mobile-category">
        <div class="mobile-category-header" (click)="category.expanded = !category.expanded">
          <span>{{ category.name }}</span>
          <i class='bx bx-chevron-down' [class.rotate]="category.expanded"></i>
        </div>
        <div class="mobile-subcategories" [class.open]="category.expanded">
          <a *ngFor="let subcategory of category.subcategories"
             [routerLink]="['/subcategory', subcategory.id]"
             class="mobile-subcategory-link">
            {{ subcategory.name }}
          </a>
        </div>
      </div>
    </div>
  </div>
</div>
